import { useQuery } from '@tanstack/react-query';

import { getIssuesForProperty } from '@/services/api/issues/api';

export const useGetIssuesForProperty = (propertyId: string) => {
  const { data, error, isLoading, isFetching, isSuccess } = useQuery({
    queryKey: ['issues-for-property', propertyId],
    queryFn: () => getIssuesForProperty(propertyId),
    enabled: Boolean(propertyId),
  });

  return {
    isInitialFetching: isLoading,
    isFetching,
    issues: data,
    isSuccess,
    error,
  };
};
